
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.571.201L8.525.176 8.5 4.222l1 .006.016-2.562 3.675 3.733-3.707 3.935.728.686 4.367-4.636-4.13-4.196 2.116.013.006-1zM.647 5.221L4.977.555l.732.68-3.674 3.96L5.74 8.903l-.004-2.551 1-.002.007 4.043L2.7 10.4l-.002-1 2.122-.004L.647 5.221z","fill":"#8A8888"}})])
          )
        }
      }
    